import { createContext } from "react";

export const AuthContext = createContext("");

export const ConfigTableContext = createContext("");

// export const CaptchaContext = createContext("");